module.exports = __webpack_public_path__ + "static/media/login-background.5b3a29b5.png";